import PropTypes from 'prop-types';
import React from 'react';
import { Col, Panel, Row } from 'react-bootstrap';

import BuildHealthSelectorContainer from './../Containers/BuildHealthSelectorContainer';
import BuildHealthDispatcherPieStatsContainer
  from './../Containers/BuildHealthDispatcherPieStatsContainer';
import BuildHealthTrendingChartContainer
  from '../Containers/BuildHealthTrendingChartContainer';
import ConditionalComponent from './ConditionalComponent';

const BuildHealthComponent = ({ isAuthenticated }) => (
  <div>
    <ConditionalComponent condition={!isAuthenticated}>
      <center>
        <p style={{ color:'orange' }}>
          Build gauges may behave differently and feedback comments cannot
          be added if not logged in with JIRA credentials.
        </p>
      </center>
    </ConditionalComponent>
    <Row>
      <Col sm={12} md={5}>
        <Row style={{ marginBottom: '15px' }}>
          <Col xs={12}>
            <BuildHealthSelectorContainer />
          </Col>
        </Row>
      </Col>
    </Row>
    <Row>
      <Col md={12}>
        <Panel bsStyle={'primary'}>
          <Panel.Heading>
            <Panel.Title>
              {'Current Release Candidate Pass/Fail Trends'}
            </Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <div style={{ height: '300px' }}>
              <BuildHealthTrendingChartContainer />
            </div>
          </Panel.Body>
        </Panel>
      </Col>
    </Row>
    <Row className="padded">
      <Col md={12}>
        <BuildHealthDispatcherPieStatsContainer
          chartWidth={3}
        />
      </Col>
    </Row>
  </div>
);

BuildHealthComponent.propTypes = { isAuthenticated: PropTypes.bool.isRequired };

export default BuildHealthComponent;


// WEBPACK FOOTER //
// src/Components/BuildHealthComponent.jsx